import * as React from 'react'
import * as Styled from './Hero.styles'

const Hero = ({
  mobileAlignImageToBottom = false,
  mainContent = null,
  children = null,
  image = null,
  mobileImage = null,
  backgroundColor = null,
  backgroundImage = null,
  mobileBackgroundImage = null,
  textColor = null,
  mobileTextColor = null,
  topPadding = null,
  bottomPadding = null,
  width = null,
  ...props
}) => (
  <Styled.Hero
    className={`leshen-hero background-color-${backgroundColor || 'default'}`}
    backgroundColor={backgroundColor}
    mobileImage={mobileImage}
    mobileAlignImageToBottom={mobileAlignImageToBottom}
    textColor={textColor}
    mobileTextColor={mobileTextColor}
    topPadding={topPadding}
    bottomPadding={bottomPadding}
    width={width}
    {...props}
  >
    {backgroundImage && (
      <Styled.DesktopBackgroundImage
        mobileBackgroundImage={mobileBackgroundImage}
      >
        {backgroundImage}
      </Styled.DesktopBackgroundImage>
    )}
    {mobileBackgroundImage && (
      <Styled.MobileBackgroundImage>
        {mobileBackgroundImage}
      </Styled.MobileBackgroundImage>
    )}
    {!mobileAlignImageToBottom && mobileImage && (
      <Styled.MobileImg
        mobileImage={mobileImage}
        mobileAlignImageToBottom={mobileAlignImageToBottom}
      >
        {mobileImage}
      </Styled.MobileImg>
    )}
    <Styled.Content className="content">
      {mainContent}
      {children}
    </Styled.Content>
    {image && (
      <Styled.BackgroundImage className="background-image" maxWidth="none">
        {image}
      </Styled.BackgroundImage>
    )}
    {mobileAlignImageToBottom && mobileImage && (
      <Styled.MobileImg
        mobileImage={mobileImage}
        mobileAlignImageToBottom={mobileAlignImageToBottom}
      >
        {mobileImage}
      </Styled.MobileImg>
    )}
  </Styled.Hero>
)

export default Hero
